import { MathNumberGroup } from "../models/NumberModel";

export const numberCards: MathNumberGroup[] = [
  {
    id: "numbers_0_10",
    title: "Números del 0 al 10",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "0", spanish: "cero" },
      { math: "1", spanish: "uno" },
      { math: "2", spanish: "dos" },
      { math: "3", spanish: "tres" },
      { math: "4", spanish: "cuatro" },
      { math: "5", spanish: "cinco" },
      { math: "6", spanish: "seis" },
      { math: "7", spanish: "siete" },
      { math: "8", spanish: "ocho" },
      { math: "9", spanish: "nueve" },
      { math: "10", spanish: "diez" },
    ],
  },
  {
    id: "numbers_11_20",
    title: "Números del 11 al 20",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "11", spanish: "once" },
      { math: "12", spanish: "doce" },
      { math: "13", spanish: "trece" },
      { math: "14", spanish: "catorce" },
      { math: "15", spanish: "quince" },
      { math: "16", spanish: "dieciséis" },
      { math: "17", spanish: "diecisiete" },
      { math: "18", spanish: "dieciocho" },
      { math: "19", spanish: "diecinueve" },
      { math: "20", spanish: "veinte" },
    ],
  },
  {
    id: "numbers_21_29",
    title: "Números del 21 al 29",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "21", spanish: "veintiuno" },
      { math: "22", spanish: "veintidós" },
      { math: "23", spanish: "veintitrés" },
      { math: "24", spanish: "veinticuatro" },
      { math: "25", spanish: "veinticinco" },
      { math: "26", spanish: "veintiséis" },
      { math: "27", spanish: "veintisiete" },
      { math: "28", spanish: "veintiocho" },
      { math: "29", spanish: "veintinueve" },
    ],
  },
  {
    id: "numbers_30s_40s",
    title: "Números 30–49",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "30", spanish: "treinta" },
      { math: "31", spanish: "treinta y uno" },
      { math: "32", spanish: "treinta y dos" },
      { math: "40", spanish: "cuarenta" },
      { math: "41", spanish: "cuarenta y uno" },
      { math: "42", spanish: "cuarenta y dos" },
    ],
  },
  {
    id: "numbers_50s_90s",
    title: "Decenas: 50–90",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "50", spanish: "cincuenta" },
      { math: "60", spanish: "sesenta" },
      { math: "70", spanish: "setenta" },
      { math: "80", spanish: "ochenta" },
      { math: "90", spanish: "noventa" },
    ],
  },
  {
    id: "numbers_100_199",
    title: "Cientos bajos: 100–199",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "100", spanish: "cien" },
      { math: "101", spanish: "ciento uno" },
      { math: "102", spanish: "ciento dos" },
      { math: "110", spanish: "ciento diez" },
      { math: "111", spanish: "ciento once" },
    ],
  },
  {
    id: "numbers_200_500",
    title: "Cientos: 200–500",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "200", spanish: "doscientos" },
      { math: "211", spanish: "doscientos once" },
      { math: "276", spanish: "doscientos setenta y seis" },
      { math: "300", spanish: "trescientos" },
      { math: "400", spanish: "cuatrocientos" },
      { math: "500", spanish: "quinientos" },
    ],
  },
  {
    id: "numbers_600_999",
    title: "Cientos altos: 600–999",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "600", spanish: "seiscientos" },
      { math: "700", spanish: "setecientos" },
      { math: "800", spanish: "ochocientos" },
      { math: "900", spanish: "novecientos" },
      { math: "999", spanish: "novecientos noventa y nueve" },
    ],
  },
  {
    id: "numbers_thousands_millions",
    title: "Miles y Millones",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "1.000", spanish: "mil" },
      { math: "1.011", spanish: "mil once" },
      { math: "1.111", spanish: "mil ciento once" },
      { math: "2.000", spanish: "dos mil" },
      { math: "3.000.003", spanish: "tres millones tres" },
    ],
  },
  {
    id: "ordinals_basic",
    title: "Números ordinales (básicos)",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "1º", spanish: "primero" },
      { math: "2º", spanish: "segundo" },
      { math: "3º", spanish: "tercero" },
      { math: "4º", spanish: "cuarto" },
      { math: "5º", spanish: "quinto" },
      { math: "6º", spanish: "sexto" },
      { math: "7º", spanish: "séptimo" },
      { math: "8º", spanish: "octavo" },
      { math: "9º", spanish: "noveno" },
    ],
  },
  {
    id: "ordinals_advanced",
    title: "Ordinales avanzados",
    topic: "Numbers",
    type: "number",
    numbers: [
      { math: "10º", spanish: "décimo" },
      { math: "11º", spanish: "undécimo" },
      { math: "20º", spanish: "vigésimo" },
      { math: "100º", spanish: "centésimo" },
    ],
  },
];
